import { render, staticRenderFns } from "./ChannableFacebookCampaign.vue?vue&type=template&id=794bd0cf"
import script from "./ChannableFacebookCampaign.vue?vue&type=script&lang=js"
export * from "./ChannableFacebookCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports